



























































































































































































































































































































import { Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'
import moment from 'moment'
import { StockShiftOrderServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import {
  WarehouseAreaServiceProxy,
  WarehouseLocationServiceProxy,
  WarehouseMaterialStockServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import _ from 'lodash'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'

const whmssp = new WarehouseMaterialStockServiceProxy()
const sksosp = new StockShiftOrderServiceProxy()
const whlsp = new WarehouseLocationServiceProxy()
const crsp = new CodeRuleServiceProxy()
const wasp = new WarehouseAreaServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'key',
    scopedSlots: { customRender: 'key' },
    width: 100,
    fixed: 'left'
  },
  {
    title: 'page_material_warehousing_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_specifications',
    dataIndex: 'materialStandardModel',
    scopedSlots: { customRender: 'materialStandardModel' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_1',
    dataIndex: 'materialStuff',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_unit',
    dataIndex: 'materialUnit',
    scopedSlots: { customRender: 'materialUnit' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_area',
    dataIndex: 'fromAreaId',
    scopedSlots: { customRender: 'fromAreaId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_warehousing_location',
    dataIndex: 'fromLocationId',
    scopedSlots: { customRender: 'fromLocationId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_out_stockNum',
    dataIndex: 'stockNum',
    scopedSlots: { customRender: 'stockNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_move_shiftNum',
    dataIndex: 'shiftNum',
    scopedSlots: { customRender: 'shiftNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_move_toArea',
    dataIndex: 'toAreaId',
    scopedSlots: { customRender: 'toAreaId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_move_toLocation',
    dataIndex: 'toLocationId',
    scopedSlots: { customRender: 'toLocationId' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_material_ware_move_remark',
    dataIndex: 'remark',
    ellipsis: true,
    scopedSlots: { customRender: 'remark' },
    width: 150
  }
]
export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      count: 1,
      dataSource: [],
      cacheData: [],
      chooseVisible: false,
      editingKey: '',
      dayTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      materialList: [], // 物料列表
      materialAddList: [],
      areaList: [], // 库区列表
      locationList: [], // 库位列表
      tolocationList: [],
      loading: false,
      codeList: [],
      shiftDeptName: '',
      shiftUserName: '',
      stockOutTypeName: '',
      stockInTypeName: '',
      value: '',
      searchMaterialValue: '',
      allAreaList: [],
      codeRule: undefined
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    outTypeList: {
      type: Array,
      default: () => []
    },
    stockInList: {
      type: Array,
      default: () => []
    },
    areaId: {
      type: String,
      default: ''
    },
    employeesList: {
      type: Array,
      default: () => []
    },
    treeList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.getList()
          this.getALLMaterial()
          this.getAreaList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    selectCodeRule(value) {
      this.form.setFieldsValue({
        orderCode: ''
      })
      this.codeRule = value
    },
    changeMaterialList(value) {
      whmssp.listAllMaterial(this.areaId, value).then((res) => {
        this.arrangementMaterial(res)
      })
    },
    getALLMaterial() {
      whmssp.listAllMaterial(this.areaId, '').then((res) => {
        this.arrangementMaterial(res)
      })
    },
    arrangementMaterial(res) {
      this.materialList = res
      this.materialList.map((item) => {
        if (item.standardModel) {
          item.displayCode = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})——${item.standardModel}(${this.$t('page_material_warehousing_specifications')})`
        } else {
          item.displayCode = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})`
        }
      })
    },
    getLocationList(record) {
      whmssp.listLocationByMaterialIdAndAreaId(this.areaId, '', record.id).then((res) => {
        this.locationList = res
      })
    },
    changeLocationList(value, record) {
      whmssp.listLocationByMaterialIdAndAreaId(this.areaId, value, record.id).then((res) => {
        this.locationList = res
      })
    },
    getAreaList() {
      wasp.listWarehouseArea('').then((res) => {
        this.allAreaList = res
      })
    },
    changeAreaList(value) {
      wasp.listWarehouseArea(value).then((res) => {
        this.allAreaList = res
      })
    },
    getToLocationList(record) {
      whlsp.listWarehouseLocationByMaterial(record.toAreaId, '', record.materialId).then((res) => {
        this.tolocationList = res
      })
    },
    changeToLocationList(value, record) {
      whlsp
        .listWarehouseLocationByMaterial(record.toAreaId, value, record.materialId)
        .then((res) => {
          this.tolocationList = res
        })
    },
    handleReceivingDeptName(val) {
      this.value = val
      this.treeList.find((item) => {
        this.forName(item)
      })
    },
    forName(item) {
      if (item.value === this.value) this.shiftDeptName = item.title
      if (item && item.hasOwnProperty('children'))
        if (item.children.length > 0)
          item.children.find((items) => {
            this.forName(items)
          })
    },
    handleShiftUserName(val) {
      let person = this.employeesList.find((items) => items.id === val)
      if (person && person.hasOwnProperty('name')) this.shiftUserName = person.name
      // console.log(111111,this.shiftUserName)
    },
    handleStockOutTypeName(val) {
      let type = this.outTypeList.find((items) => items.id === val)
      if (type && type.hasOwnProperty('name')) this.stockOutTypeName = type.name
      // console.log(111111,this.stockOutTypeName)
    },
    handleStockInTypeName(val) {
      let type = this.stockInList.find((items) => items.id === val)
      if (type && type.hasOwnProperty('name')) this.stockInTypeName = type.name
      // console.log(111111,this.stockInTypeName)
    },
    async getList() {
      let result = await crsp.list('StockShiftObject')
      this.codeList = result.map((item) => ({ label: item.name, value: item.id }))
    },
    moment,
    handleDelete(sort) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== sort)
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      if (target) {
        if (column === 'toAreaId') {
          const area = this.allAreaList.find((res) => res.id === value)
          target['toAreaName'] = area.name
          target['toLocationId'] = ''
          target['toLocationName'] = ''
        }
        target[column] = value
        this.dataSource = newData
      }
    },
    handleChangeLocationId(value, record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let num = 0
      whmssp.listWarehouseMaterialStock(value, record.id).then((res) => {
        if (res) {
          num = res.length > 0 ? res[0].locationNum : num
          if (target) {
            target['fromLocationId'] = value
            const area = this.locationList.find((res) => res.id === value)
            target['fromLocationName'] = area.name
            target['stockNum'] = num + ''
            this.dataSource = newData
          }
        }
      })
    },
    handleChangeToLocationId(value, record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let same = false
      newData.forEach((res) => {
        if (res.toLocationId === value && record.id === res.id) {
          same = true
        }
      })
      if (same) {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_be_same'))
        return
      }
      if (target) {
        target['toLocationId'] = value
        const area = this.tolocationList.find((res) => res.id === value)
        target['toLocationName'] = area.warehouseLocationName
        this.dataSource = newData
      }
    },
    edit(record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      console.log(newData)
      this.editingKey = record.key
      if (target) {
        const area = this.allAreaList.find((res) => res.id === this.areaId)
        target['fromAreaId'] = this.areaId
        target['fromAreaName'] = area.name
        target.editable = true
        this.dataSource = newData
      }
    },
    saveTableEdit(key) {
      const newData = [...this.dataSource]
      const newCacheData = [...this.cacheData]
      const target = newData.filter((item) => key === item.key)[0]
      const targetCache = newCacheData.filter((item) => key === item.key)[0]
      if (target.materialId === '') {
        this.$message.warning('物料未选择')
        return
      }
      if (target.fromAreaId === '') {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_area'))
        return
      }
      if (target.fromLocationId === '') {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_location'))
        return
      }
      if (target.toAreaId === '') {
        this.$message.warning(this.$t('page_material_ware_not_to_area'))
        return
      }
      if (target.toLocationId === '') {
        this.$message.warning(this.$t('page_material_ware_not_to_location'))
        return
      }
      if (target.shiftNum === undefined || target.shiftNum === null) {
        this.$message.warning(this.$t('page_material_ware_not_to_move_number'))
        return
      }
      if (target && targetCache) {
        delete target.editable
        this.dataSource = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
      this.editingKey = ''
    },
    cancelTableEdit(key) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.key)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.key)[0])
        delete target.editable
        this.dataSource = newData
      }
    },
    addMaterial() {
      const { count, dataSource } = this
      this.editingKey = count
      const newData = {
        key: count,
        editable: true,
        id: '',
        fromAreaId: '',
        fromAreaName: '',
        fromLocationId: '',
        fromLocationName: '',
        materialCode: '',
        materialId: '',
        materialName: '',
        materialStandardModel: '',
        materialStuff: '',
        materialTypeName: '',
        materialUnit: '',
        remark: '',
        stockNum: 0,
        shiftNum: 0,
        toAreaId: '',
        toAreaName: '',
        toLocationId: '',
        toLocationName: '',
        displayCode: ''
      }
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    },
    changeMaterial(value, record) {
      const newData = [...this.dataSource]
      const material = this.materialList.find((res) => res.displayCode === value)
      const checkTarget = newData.find((res) => res.id === material.id)
      if (checkTarget) {
        this.$message.warning('不能选择重复物料')
        return
      }
      console.log(material, '<==material')
      const target = newData.find((res) => res.key === record.key)
      console.log(target, '<==target')
      const area = this.allAreaList.find((item) => item.id == this.areaId)
      console.log(area, '<==material')
      if (area) {
        whmssp.listLocationByMaterialIdAndAreaId(this.areaId, '', material.id).then((res) => {
          this.locationList = res
        })
      }
      if (target) {
        target.id = material.id
        target.displayCode = material.displayCode
        target.fromAreaId = this.areaId
        target.fromAreaName = area.name
        target.materialCode = material.code
        target.materialId = material.id
        target.materialName = material.name
        target.materialStandardModel = material.standardModel
        target.materialStuff = material.stuff
        target.materialTypeName = material.typeName
        target.materialUnit = material.unit
        this.dataSource = newData
        this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
      }
    },
    close() {
      this.form.resetFields()
      this.dataSource = []
      this.editingKey = ''
      this.$emit('close')
    },
    save() {
      if (this.editingKey !== '') {
        this.$message.warning(this.$t('page_material_ware_first_save_material'))
        return
      }
      let mesg = 0
      this.dataSource.forEach((element, index) => {
        if (element.materialId === '') {
          this.$message.warning('物料未选择')
          mesg = mesg + 1
          return
        }
        if (element.fromAreaId === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_area'))
          mesg = mesg + 1
          return
        }
        if (element.fromLocationId === '') {
          this.$message.warning(this.$t('page_plan_refund_confirmation_not_location'))
          mesg = mesg + 1
          return
        }
        if (element.toAreaId === '') {
          this.$message.warning(this.$t('page_material_ware_not_to_area'))
          mesg = mesg + 1
          return
        }
        if (element.toLocationId === '') {
          this.$message.warning(this.$t('page_material_ware_not_to_location'))
          mesg = mesg + 1
          return
        }
        if (element.shiftNum === undefined || element.shiftNum === null) {
          this.$message.warning(this.$t('page_material_ware_not_to_move_number'))
          mesg = mesg + 1
          return
        }
      })
      if (mesg > 0) return
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          const list = _.cloneDeep(this.dataSource)
          list.forEach((res) => {
            delete res.id
            delete res.displayCode
            delete res.key
          })
          values.list = list
          values.shiftTime = dayjs(values.shiftTime).format('YYYY-MM-DD HH:mm:ss')
          values.shiftDeptName = this.shiftDeptName
          values.shiftUserName = this.shiftUserName
          values.stockOutTypeName = this.stockOutTypeName
          values.stockInTypeName = this.stockInTypeName
          sksosp
            .createStockShiftOrder(values)
            .then(() => {
              this.form.resetFields()
              this.dataSource = []
              this.loading = false
              this.$message.success(this.$t('page_user_management_new_success'))
              this.$emit('reload')
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
})
